import axios from "../axios";

// GET endpoints
export async function fetchReportVariables(reportId) {
  return axios
    .get(`/service/reports/${reportId}/variables`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function fetchReportVariableGroups(reportId) {
  return axios
    .get(`/service/reports/${reportId}/variable_groups`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function fetchReportVariableTypeGroups(reportId) {
  return axios
    .get(`/service/reports/${reportId}/variable_type_groups`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

// Variable Groups
export async function createReportVariableGroup(reportId, payload, options = {}) {
  return axios
    .post(`/service/reports/${reportId}/variable_groups`, {
      variable_group: payload,
      ...(options.editVersion !== undefined ? { edit_version: options.editVersion } : {}),
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function updateReportVariableGroup(reportId, groupId, payload, options = {}) {
  return axios
    .put(`/service/reports/${reportId}/variable_groups/${groupId}`, {
      variable_group: payload,
      ...(options.editVersion !== undefined ? { edit_version: options.editVersion } : {}),
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function deleteReportVariableGroup(reportId, groupId, options = {}) {
  return axios
    .delete(`/service/reports/${reportId}/variable_groups/${groupId}`, { data: options.editVersion !== undefined ? { edit_version: options.editVersion } : {} })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

// Variables
export async function createReportVariable(reportId, payload, options = {}) {
  return axios
    .post(`/service/reports/${reportId}/variables`, {
      variable: payload,
      ...(options.editVersion !== undefined ? { edit_version: options.editVersion } : {}),
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function updateReportVariable(reportId, variableId, payload, options = {}) {
  return axios
    .put(`/service/reports/${reportId}/variables/${variableId}`, {
      variable: payload,
      ...(options.editVersion !== undefined ? { edit_version: options.editVersion } : {}),
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function deleteReportVariable(reportId, variableId, options = {}) {
  return axios
    .delete(`/service/reports/${reportId}/variables/${variableId}`, { data: options.editVersion !== undefined ? { edit_version: options.editVersion } : {} })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

// Measurements
export async function createReportVariableMeasurement(reportId,
  variableId,
  payload, options = {}) {
  return axios
    .post(`/service/reports/${reportId}/variables/${variableId}/measurements`, {
      measurement: payload,
      ...(options.editVersion !== undefined ? { edit_version: options.editVersion } : {}),
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function fetchReportVariableMeasurements(reportId, variableId) {
  return axios
    .get(`/service/reports/${reportId}/variables/${variableId}/measurements`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function deleteReportVariableMeasurement(reportId,
  variableId,
  measurementId, options = {}) {
  return axios
    .delete(
      `/service/reports/${reportId}/variables/${variableId}/measurements/${measurementId}`,
      { data: options.editVersion !== undefined ? { edit_version: options.editVersion } : {} }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

// Variable Type Groups
export async function createReportVariableTypeGroup(reportId, payload, options = {}) {
  return axios
    .post(`/service/reports/${reportId}/variable_type_groups`, {
      variable_type_group: payload,
      ...(options.editVersion !== undefined ? { edit_version: options.editVersion } : {}),
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function updateReportVariableTypeGroup(reportId, typeGroupId, payload, options = {}) {
  return axios
    .put(`/service/reports/${reportId}/variable_type_groups/${typeGroupId}`, {
      variable_type_group: payload,
      ...(options.editVersion !== undefined ? { edit_version: options.editVersion } : {}),
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function deleteReportVariableTypeGroup(reportId, typeGroupId, options = {}) {
  return axios
    .delete(`/service/reports/${reportId}/variable_type_groups/${typeGroupId}`, { data: options.editVersion !== undefined ? { edit_version: options.editVersion } : {} })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}


